import service from './request';

export function getAboutData() { return service.get('/api/front/about'); }
